<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <span class="decoration">Service</span>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <router-link class="decoration" to="/cmmsservicejob/index">Manage Repair Jobs</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Create Repair Job
      </h6>

      <div class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body custom_bdr_rds">
            <div v-if="message" class="alert alert-success py-2">{{ message }}</div>
            <div v-if="errorMessage" class="alert alert-danger py-2">{{ errorMessage }}</div>

            <form @submit.prevent="createRepairJob">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="custom-label" style="font-size: small">Asset Code <span class="text-danger">*</span></label>
                    <select v-model="form.inv_id" class="form-control form-control-sm bdr-rad" required @change="setDescription">
                      <option value="">Select Asset</option>
                      <option v-for="asset in assets" :key="asset.value" :value="asset.value">{{ asset.label }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small">Asset Description</label>
                    <input v-model="form.description" class="form-control form-control-sm bdr-rad" readonly />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="custom-label" style="font-size: small">Scheduled Date <span class="text-danger">*</span></label>
                    <input v-model="form.scheduled_date" type="date" class="form-control form-control-sm bdr-rad" required />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small">Remarks</label>
                    <textarea v-model="form.remark" rows="3" class="form-control form-control-sm bdr-rad"></textarea>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-3">
                <router-link to="/cmmsservicejob/index" class="btn btn-sm btn-outline-primary bdr-rad mr-2">Back</router-link>
                <button type="submit" class="btn btn-sm btn-outline-primary bdr-rad" :disabled="isSaving">
                  {{ isSaving ? "Saving..." : "Create" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <br /><br />
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      assets: [],
      descriptions: [],
      form: { inv_id: "", description: "", scheduled_date: "", remark: "" },
      message: "",
      errorMessage: "",
      isSaving: false,
    };
  },
  mounted() {
    this.loadAssets();
  },
  methods: {
    async loadAssets() {
      try {
        const { data } = await axios.get("/cserviceevent/loaddata", {
          headers: { Authorization: "Bearer " + this.access_token },
        });
        this.assets = data.inventrs || [];
        this.descriptions = data.inventrs2 || [];
      } catch (error) {
        this.errorMessage = (error.response && error.response.data && error.response.data.message) || "Unable to load assets.";
      }
    },
    setDescription() {
      const description = this.descriptions.find((item) => String(item.value) === String(this.form.inv_id));
      this.form.description = description ? description.label : "";
    },
    async createRepairJob() {
      this.isSaving = true;
      this.message = "";
      this.errorMessage = "";
      try {
        const { data } = await axios.post("/cserviceevent/repairjobcreate", { event: this.form }, {
          headers: { Authorization: "Bearer " + this.access_token },
        });
        if (!data || data.status !== 200) throw new Error((data && data.message) || "Unable to create repair job.");
        this.$router.push("/cmmsservicejob/index");
      } catch (error) {
        this.errorMessage = (error.response && error.response.data && error.response.data.message) || error.message || "Unable to create repair job.";
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
